module.exports = __webpack_public_path__ + "img/blank-avatar.c0db2697.png";